<template>
    <div>
        <!-- <alert-notification v-if="notification_msg != ''" /> -->
        <loader v-if="pageLoader" />
        <form action="" method="post" enctype="multipart/form-data" id="formRequest" v-on:submit.prevent="addBankDetails()"> 
            <div class="row">
                <div class="col-6">
                    <label class="mb-3 semibold themecolor">Bank Details</label>
                    <!-- <input type="text" placeholder="Description" class="form-control mb-2">
                    <span class="f-12 textcolor">In case you add multiple accounts, please add a description for identifying your bank account</span> -->

                    <div class="form-group">
                        <label class="mb-2">International Bank Account Number (IBAN)</label>
                        <input type="text" placeholder="International Bank Account Number (IBAN)" class="form-control mb-2" v-model="account_no" name="account_no"   v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('account_no')" class="text-danger">{{ errors.first("account_no") }}</span>
                    </div>
                    <div class="form-group">
                        <label class="mb-2">Bank Name</label>
                        <input type="text" placeholder="Bank Name" class="form-control mb-2" v-model="bank_name"  name="bank_name"  v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('bank_name')" class="text-danger">{{ errors.first("bank_name") }}</span>
                    </div>
                    <div class="form-group">
                        <label class="mb-2">BIC/SWIFT Code/Sort Code/ IFSC </label>
                        <input type="text" placeholder="BIC/SWIFT Code/Sort Code/ IFSC" class="form-control mb-2" v-model="ifsc"  name="ifsc"   v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('ifsc')" class="text-danger">The BIC/SWIFT Code/Sort Code/ IFSC is required</span> 
                    </div>
                   <!--  <div class="form-group">
                        <label class="mb-2">IFSC Code</label>
                        <input type="text" placeholder="IFSC Code" class="form-control mb-2" v-model="ifsc"  name="ifsc"   v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('ifsc')" class="text-danger">{{ errors.first("ifsc") }}</span> 
                    </div> -->
                    <div class="form-group">
                        <label class="mb-2">Bank Address</label>
                        <input type="text" placeholder="Bank Address" class="form-control mb-2" v-model="bank_address" name="bank_address"  v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('bank_address')" class="text-danger">{{ errors.first("bank_address") }}</span>
                    </div>
                    
                    <div class="field-wrapper">
                        <label class="mb-2">Upload Bank Document</label>
                        <div class="supportingdocument w-100" v-show="document_proof_array.bank == ''">
                          <p class="btn" @click="$refs.bank.click()"><feather type="upload" class="mr-2"></feather>Upload Bank Document</p>
                          <input type="file"  name="document[]" value="Upload Document" ref="bank" v-on:change="onFileChange('bank', $event.target.files)"/>    
                        </div>
                        <div class="linerUpload d-flex align-items-center mb-2" v-if="document_proof_array.bank != ''">
                          <span class="nameIco"><feather class="mr-2" type="file"></feather> {{document_proof_array.bank}}  </span>
                          <a href="#" class="closeBtn" @click="clearDoc('bank')"><feather type="x"></feather></a>
                        </div>
                    </div> 
                </div>
                <div class="col-6">

                    <label class="mb-3 semibold themecolor">Beneficiary Details</label>

                    <div class="form-group">
                        <label class="mb-2">Beneficiary Name</label>
                        <input type="text" placeholder="Beneficiary Name" class="form-control mb-2" v-model="beneficiary_name"  name="beneficiary_name"  v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('beneficiary_name')" class="text-danger">{{ errors.first("beneficiary_name") }}</span>
                    </div>

                    <div class="form-group">
                        <label class="mb-2">Beneficiary Country</label>
                        <v-select  :options="Object.values($env_var.countriesList)" :reduce="country => country.code" v-model="country" label="name" placeholder="Beneficiary Country" name="country" v-validate="'required'" class="form-control mb-3"  :autocomplete="'off'"></v-select>
                        <!-- <input type="text" placeholder="Beneficiary Country" class="form-control mb-3" v-model="baneficiary_country"  name="baneficiary_country" required=""  v-validate="{ required: true }"> -->
                        <span v-if="bankSubmitted && errors.has('country')" class="text-danger">{{ errors.first("country") }}</span>
                    </div>

                    <div class="form-group">
                        <label class="mb-2">Beneficiary City</label>
                        <input type="text" placeholder="Beneficiary City" class="form-control mb-2" v-model="city"  name="city"   v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('city')" class="text-danger">{{ errors.first("city") }}</span>
                    </div>
                    <div class="form-group">
                        <label class="mb-2">Beneficiary Address</label>
                        <input type="text" placeholder="Beneficiary Address" class="form-control mb-2" v-model="address"  name="address"   v-validate="{ required: true }">
                        <span v-if="bankSubmitted && errors.has('address')" class="text-danger">{{ errors.first("address") }}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
                <button class="cap_btn large_btn secondaryBG w-100 mt-3"  :class="(pageLoader)?'disabled':''">Add Bank Account</button> 
            </div>
        </form>
    </div>
</template>
<script>
  import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
  import { Const } from "@/plugins/vue-provider-cache/const.mod";
  import tradingMixins from "@/plugins/trading";

  export default {
    name: "deposit-section",
    mixins: [depositWithdrawalMixins, tradingMixins],
    data() {
      return {
        pageLoader: false,

        bankSubmitted : false,
        account_no : '',
        bank_name : '',
        micr : '',
        bank_address : '',
        beneficiary_name : '',
        country : '',
        city : '',
        ifsc : '',
        address : '',
        document_proof_array : {
            'bank' : ''
        },
      };
    },
    computed: {},
    props : ['pageNameData'],
    methods: {
        onFileChange(getdocType , file) {
            this.document_proof_array[getdocType] = file[0].name
        },
        clearDoc(getdocType){
            this.document_proof_array[getdocType] = ''
        },
        reset(){
            this.bankSubmitted = false
            this.account_no = ''
            this.bank_name = ''
            this.micr = ''
            this.bank_address = ''
            this.beneficiary_name = ''
            this.country = ''
            this.ifsc = ''
            this.city = ''
            this.address = ''
            this.document_proof_array = {
                'bank' : ''
            }
        },
        addBankDetails() {
            const _that = this;
            _that.bankSubmitted = true;
            let formRequest = document.getElementById('formRequest');
            let form_name = new FormData(formRequest);
            form_name.append("country", _that.country);
            _that.$validator.validate().then((valid) => {
                if (valid) {
                    let json = {
                        globalParams: {
                            'form' : form_name
                        },
                        localParams: { parameter: _that, pagename :  _that.pageNameData,  'type' :'form'},
                    }
                    _that._runAddBankDetails(json);
                }
            })
        }
    },
    created() {
        this.reset()
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/website/bank/add-bank.vue